import { render } from "./textarea.vue?vue&type=template&id=5b1c0e5f"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/form/field/textarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b1c0e5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b1c0e5f', __exports__)) {
    console.log('reload')
    api.reload('5b1c0e5f', __exports__)
  }
  
  module.hot.accept("./textarea.vue?vue&type=template&id=5b1c0e5f", () => {
    console.log('re-render')
    api.rerender('5b1c0e5f', render)
  })

}


export default __exports__